import React, { memo } from 'react';
import { Box } from '@chakra-ui/react';

export const MessageWrapper = memo(({ children, ...props }) => (
  <Box display="flex" gap="8px" alignItems="center" {...props}>
    {children}
  </Box>
));
